<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{this.title | translate}}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 md6>
                        <vue-plotly :white-mode="whiteMode" v-if="data1" disable-responsive :data="data1" :layout="layout1" :options="{}"/>
                    </v-flex>
                    <v-flex xs12 md6>
                        <vue-plotly :white-mode="whiteMode" v-if="data2" disable-responsive :data="data2" :layout="layout2" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from 'moment'
    import {getCOP} from '@/helper'
    import VuePlotly from "@/components/VuePlotly";
    export default {
        props: {
          title: {type: String, default: 'Cooling Load VS Outdoor Temperature'},
          xTitle: {type: String, default: 'Outdoor Temperature (°C)'},
          yTitle: {type: String, default: 'Cooling Load (kW)'},
          dateRange: {type: Object, default: null},
            whiteMode:{type:Boolean, default: false},
        },
        name: 'CoolingLoadVsOatWidget',
        components: {VuePlotly},
        data () {
            return {
                loading:true,
                timeout: null,
                data1:null,
                data2:null,
                layout1:{
                    title: this.title + ': Day Mode',
                    yaxis: {
                        title: this.$options.filters.translate(this.yTitle)
                    },
                    xaxis: {
                        title: this.$options.filters.translate(this.xTitle)
                    },
                    legend: {
                        orientation: 'h',
                        traceorder:'normal',
                        y:-0.2
                    },
                    showlegend:true,
                    hoverlabel: {
                        namelength: -1,
                    },
                    margin:{
                        l: 50,
                        r: 50,
                        t: 50,
                        pad: 1
                    },
                },
                layout2:{
                    title: this.title + ': Night Mode',
                    yaxis: {
                        title: this.$options.filters.translate(this.yTitle)
                    },
                    xaxis: {
                        title: this.$options.filters.translate(this.xTitle)
                    },
                    legend: {
                        orientation: 'h',
                        traceorder:'normal',
                        y:-0.3
                    },
                    showlegend:true,
                    hoverlabel: {
                        namelength: -1,
                    },
                    margin:{
                        l: 50,
                        r: 50,
                        t: 30,
                        pad: 1
                    },
                },
            }
        },
        watch: {
            dateRange(){
                this.getData()
            }
        },
        mounted() {
            this.refresh();
        },
        methods:{
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,500);
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.dateRange.start, me.dateRange.end]
                getCOP({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    from_date: currentRange[0],
                    to_date: currentRange[1],
                    extra_vars: [{
                        'equipment_name': 'Weather',
                        'sensor_names': ['Outdoor_Temperature']
                    }]
                }).then(function(result){
                    let splitData={
                       day:{
                           weekday:{
                               "Cooling_Load":[],
                               "Outdoor_Temperature":[],
                               "timestamp":[]
                           },
                           weekend:{
                               "Cooling_Load":[],
                               "Outdoor_Temperature":[],
                               "timestamp":[]
                           }
                       },
                       night:{
                           weekday:{
                               "Cooling_Load":[],
                               "Outdoor_Temperature":[],
                               "timestamp":[]
                           },
                           weekend:{
                               "Cooling_Load":[],
                               "Outdoor_Temperature":[],
                               "timestamp":[]
                           }
                       }
                    }
                    for (let index in result.timestamp){
                        let theTime = moment(result.timestamp[index])
                        let firstIndex= theTime.hour()<5 ? "night" : "day"
                        let secondIndex= theTime.day() === 6 || theTime.day() === 0 ? "weekend" : "weekday"
                        splitData[firstIndex][secondIndex].timestamp.push(result.timestamp[index])
                        splitData[firstIndex][secondIndex].Cooling_Load.push(result.Cooling_Load[index])
                        splitData[firstIndex][secondIndex].Outdoor_Temperature.push(result.Outdoor_Temperature[index])
                    }
                    me.data1=[
                        {
                            x:splitData.day.weekday.Outdoor_Temperature,
                            y:splitData.day.weekday.Cooling_Load,
                            hovertext:splitData.day.weekday.timestamp,
                            mode:"markers",
                            name:"Weekday"
                        },
                        {
                            x:splitData.day.weekend.Outdoor_Temperature,
                            y:splitData.day.weekend.Cooling_Load,
                            hovertext:splitData.day.weekend.timestamp,
                            mode:"markers",
                            name:"Weekend"
                        }
                    ]
                    me.data2=[
                        {
                            x:splitData.night.weekday.Outdoor_Temperature,
                            y:splitData.night.weekday.Cooling_Load,
                            hovertext:splitData.night.weekday.timestamp,
                            mode:"markers",
                            name:"Weekday"
                        },
                        {
                            x:splitData.night.weekend.Outdoor_Temperature,
                            y:splitData.night.weekend.Cooling_Load,
                            hovertext:splitData.night.weekend.timestamp,
                            mode:"markers",
                            name:"Weekend"
                        }
                    ]
                    me.loading=false
                })
            }
        },
    }
</script>
